import axios from "axios"
import { handleChangeCart } from "../components/cart-state.js"
import { sendProductAddedToCartEvent } from "@surf-turf/nemo/assets/utils-events"

class ShopifyServices {
  /**
   * Update cart with a axios call.
   *
   * @param method {string}
   * @param url {string}
   * @param selectedElement {HTMLElement}
   * @param body {string}
   */
  async updateCart(method, url, selectedElement, body) {
    try {
      if (selectedElement) {
        selectedElement.classList.add("js-is-loading")
      }

      await axios({
        method: method,
        url: url,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest",
        },
        data: body,
      }).then((response) => {
        const responseData = response.data
        //console.log(responseData)
        if (responseData.token) {
          handleChangeCart(responseData)
          this.updatecartWithGifts(responseData)
        } else {
          handleChangeCart(responseData)
          this.getCartandUpdateGifts()
        }
      })
    } catch (error) {
      // Check if the error is related to all the available items being in the cart.
      if (error.response ? error.response.status === 422 : false) {
        if (selectedElement) {
          selectedElement.classList.remove("js-is-loading")
          selectedElement.classList.add("js-all-in-cart")
        }
      } else {
        if (selectedElement) {
          selectedElement.classList.remove("js-is-loading")
          selectedElement.classList.add("js-change-failed")
        }
      }
    }
  }

  async getCartandUpdateGifts() {
    await axios({
      method: "GET",
      url: window.Shopify.routes.root + "cart.js",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "X-Requested-With": "xmlhttprequest",
      },
    }).then((response) => {
      const responseData = response.data
      this.updatecartWithGifts(responseData)
    })
  }

  updatecartWithGifts(responseData) {
    const selected_gifts_elements = document.querySelectorAll(".gift-button:not([disabled])")
    const all_gifts = document.querySelector(".gift-id-data") ? JSON.parse(document.querySelector(".gift-id-data").innerHTML) : []
    let updates = {}
    let selected_gifts = { selected_gifts: [] }

    //if (responseData.total_price < 1) return false

    selected_gifts_elements.forEach((item) => {
      if (item.dataset.variantId) {
        updates[item.dataset.variantId + `:936d367b536534ab078216f37eeb6799`] = 1
        selected_gifts.selected_gifts.push({
          id: Number(item.dataset.variantId),
        })
      }
    })

    //console.log(updates)
    //console.log(selected_gifts)

    //onst gifts = all_gifts.all_gifts.concat(selected_gifts.selected_gifts)

    all_gifts.all_gifts.forEach((item) => {
      const present = selected_gifts.selected_gifts.some((selected_item) => selected_item.id === item.id)
      if (!present) {
        updates[item.id] = 0
      }
    })

    let updates2 = updates
    let updates3 = updates

    //console.log(updates)

    Object.entries(updates2).forEach(([key, value]) => {
      //console.log(`Key: ${key}, Value: ${value}`)

      const manually_added = responseData.items.find((item) => item.id === Number(key) && item.properties._manual == "yes")
      if (manually_added) {
        //updates[key] = value + 1
        //updates[key + `:44a811431a9586600915b706da008721`] = value
        updates[manually_added.key] = 1
      }
    })
    //console.log(updates)

    Object.entries(updates3).forEach(([key, value]) => {
      //console.log(`Key: ${key}, Value: ${value}`)

      if (value === 0) {
        const found = responseData.items.find((item) => item.id === Number(key) && Object.keys(item.properties).length === 0)
        //console.log(found)
        if (found) {
          delete updates[key]
          updates[found.key] = value
        }
      }
    })

    //console.log(updates)

    const data = {
      updates,
      attributes: {},
    }

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        //console.log(data)

        fetch(window.Shopify.routes.root + "?sections=cart-drawer")
          .then((response) => response.json())
          .then((data) => {
            const drawerElement = new DOMParser().parseFromString(data["cart-drawer"], "text/html")
            //console.log(data)

            const html = drawerElement.querySelector("#cart-items")?.innerHTML
            const counter = drawerElement.querySelector(".count-holder-container")?.innerHTML

            //console.log(counter)

            if (html) {
              document.querySelector("#cart-items").innerHTML = html
              document.querySelector(".count-holder-container").innerHTML = counter
            }
          })
      })
      .catch((error) => {
        //console.error('Error:', error);
      })
  }
}

export default ShopifyServices
